import { IconProps } from './IconProps';

export const ArrowTopRight = (props: IconProps) => {
  return (
    <svg
      className={props.className}
      style={props.style}
      width="22"
      height="23"
      viewBox="0 0 22 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.9363 1.97422V0.75366L20.7158 0.753662H1.72831L1.72831 3.19478H17.9724L0.866059 20.3011L2.59219 22.0272L19.4952 5.1242V20.9617L21.9363 20.9617V1.97422Z"
        fill={props.fill ?? '#ffffff'}
      />
    </svg>
  );
};

